import { Container } from './_hero';
import { PrimaryButton } from '../../atoms/PrimaryButton/PrimaryButton';

export const Hero = () => {
  return (
    <Container className="hero">
      <div className="hero__content">
        <div className="hero__caption">
          <h1 className="hero__title">
            <span>
              <b className="hero__title-b">Vamos </b>{' '}
              <b className="hero__title-b--second ">juntos</b>
            </span>
            <span className="hero__title-message">começar essa</span>
            <span className="hero__title-message">jornada</span>
          </h1>

          <legend className="hero__description">
            Aproveite 1 semana grátis
          </legend>

          <legend className="hero__description2">
            Depois, pague somente R$ 19,00/mês
          </legend>

          <PrimaryButton href={'/escolha-um-plano'}>
            Assine agora!
          </PrimaryButton>
        </div>

        <div />
      </div>
    </Container>
  );
};
